import { useTranslation } from 'react-i18next'
import { Trash2 } from 'lucide-react'
import type { AddToProductTarget } from '../../types'

interface Props {
  target: AddToProductTarget
  onDelete: (target: AddToProductTarget) => void
}

/**
 * Hover-revealed trash button for occupied slots. Positioned at top-2 right-10
 * so it does not collide with the SlotNumberBadge at top-2 right-2. Stops
 * propagation so the click never starts a drag on the surrounding slot.
 */
export function SlotDeleteButton({ target, onDelete }: Props) {
  const { t } = useTranslation()
  return (
    <button
      type="button"
      aria-label={t('addToProduct.media.slotDelete')}
      onClick={(e) => {
        e.stopPropagation()
        onDelete(target)
      }}
      onPointerDown={(e) => e.stopPropagation()}
      className="absolute top-2 right-10 inline-flex items-center justify-center w-7 h-7 rounded-md bg-white/90 dark:bg-neutral-900/90 text-red-600 hover:bg-white hover:text-red-700 shadow-sm opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity"
    >
      <Trash2 className="w-4 h-4" />
    </button>
  )
}
